import Comp from '../assets/companies/compa.svg';
import Foundry from '../assets/companies/foundry.svg';
import Solana from '../assets/companies/solana.svg';
import Invisible from '../assets/companies/invisible.svg';
import Techstars from '../assets/companies/techstars.svg';
import Ecosystem from '../assets/icon-ecosystem.svg';
import Company from '../assets/icon-company.svg';
import FlyFlat from '../assets/companies/flyFlat.svg';

export const networkTypes = [
  {
    id: 'company',
    name: 'Company',
    icon: Company,
    description: 'A business looking to accelerate growth by leveraging its extended network.',
    icons: [Comp, Invisible, FlyFlat],
  },
  {
    id: 'ecosystem',
    name: 'Ecosystem',
    icon: Ecosystem,
    description: 'A network-driven organization, like a VC firm or accelerator, that wants to support their companies.',
    icons: [Techstars, Solana, Foundry],
  },
];
